import React, { Fragment } from "react";
import { Col, Form, Row } from "reactstrap";
import InterestPricing from "./InterestPricing";
// import TutorInterestAndPricing from "./TutorInterestAndPricing";
import { useNavigate } from "react-router-dom";
import { Btn } from "../../../../AbstractElements";
const TutorPricing = () => {
  const navigate = useNavigate();

  const submitFun = () => {
    //window.location.reload();
    navigate(`${process.env.PUBLIC_URL}/profile/me`);
  };
  return (
    <Fragment>
      <Row>
        <Col sm="12">
          <Form className="needs-validation" noValidate>
            {/* <TutorInterestAndPricing /> */}
            <InterestPricing />
          </Form>
        </Col>
      </Row>
      <Btn
        attrBtn={{
          color: "warning",
          className: "pull-right",
          onClick: submitFun,
        }}
      >
        {"Finish"}
      </Btn>
    </Fragment>
  );
};
export default TutorPricing;
